import React, { useState } from "react";
import styles from "./userInfoDropdown.module.scss";
import { NavLink } from "react-router-dom";
import LogoIcon from "../../assets/images/header/icons/LogoDropDownpng.png";
import BoxIcon from "../../assets/images/header/icons/box.svg";
import BagIcon from "../../assets/images/header/icons/bag-outline.svg";
import Accİon from "../../assets/images/header/icons/order.svg";
import AccİonLight from "../../assets/images/header/icons/order-light.svg";
import PersonIcon from "../../assets/images/header/icons/person.svg";
import BoxIconLight from "../../assets/images/header/icons/boxIconLight.svg";
import BagIconLight from "../../assets/images/header/icons/BagIconLight.svg";
import PersonIconLight from "../../assets/images/header/icons/PersonIconLight.svg";
import LogoutIcon from "../../assets/images/header/icons/logout.svg";
interface HeaderDropdownProps {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  user: any;
  translations?: any;
}

const UserInfoDropdown: React.FC<HeaderDropdownProps> = ({
  onMouseEnter,
  onMouseLeave,
  user,
  translations,
}) => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const handleMouseEnter = (itemName: string) => {
    setHoveredItem(itemName);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  return (
    <div
      className={styles.dropdownContainer}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.dropDownContent}>
        <div className={styles.servicesLeftContent}>
          <h2 className={styles.servicesLeftTitle}>
            {translations?.control_account}
          </h2>
          <div className={styles.iconText}>
            <img className={styles.servicesLeftImg} src={LogoIcon} alt="Logo" />
            <p className={styles.servicesLeftText}>
              {translations?.our_slogan}
            </p>
          </div>
        </div>

        <div className={styles.dropDownLeft}>
          <ul className={styles.itemList}>
            <li className={styles.itemsTitle}>{user?.name}</li>
            <li
              className={styles.item}
              onMouseEnter={() => handleMouseEnter("accountInfo")}
              onMouseLeave={handleMouseLeave}
            >
              <NavLink to={"/accountInfo"} className={styles.link}>
                <img
                  src={
                    hoveredItem === "accountInfo" ? PersonIconLight : PersonIcon
                  }
                  alt="Hesab"
                />
                {translations?.my_info}
              </NavLink>
            </li>
            <li
              className={styles.item}
              onMouseEnter={() => handleMouseEnter("orders")}
              onMouseLeave={handleMouseLeave}
            >
              <NavLink to={"/orders"} className={styles.link}>
                <img
                  src={hoveredItem === "orders" ? BoxIconLight : BoxIcon}
                  alt="orders"
                />{" "}
                {translations?.my_orders}
              </NavLink>
            </li>
            <li
              className={styles.item}
              onMouseEnter={() => handleMouseEnter("services")}
              onMouseLeave={handleMouseLeave}
            >
              <NavLink to={"/serviceOrders"} className={styles.link}>
                <img
                  src={hoveredItem === "services" ? BagIconLight : BagIcon}
                  alt="orders"
                />{" "}
                {translations?.my_service_orders}
              </NavLink>
            </li>
            <li
              className={styles.item}
              onMouseEnter={() => handleMouseEnter("accessory")}
              onMouseLeave={handleMouseLeave}
            >
              <NavLink to={"/accessoryOrders"} className={styles.link}>
                <img
                  src={hoveredItem === "accessory" ? AccİonLight : Accİon}
                  alt="orders"
                />{" "}
                {translations?.my_accessory_orders}
              </NavLink>
            </li>
            <li className={styles.item}>
              <NavLink
                to={"/exit"}
                className={styles.link}
                style={{ color: "red" }}
              >
                <img src={LogoutIcon} alt="Çıxış" />
                {translations?.log_out}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UserInfoDropdown;
